var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierChainOptimizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22V9.975L9 7V9L14 7V10H22V22H2ZM4 20H20V12H12V9.95L7 11.95V10L4 11.325V20ZM11 18H13V14H11V18ZM7 18H9V14H7V18ZM15 18H17V14H15V18ZM22 10H17L18 2H21L22 10Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierChainOptimizationIcon);
export default __webpack_public_path__ + "static/media/supplier-chain-optimization-icon.aaec2c296532ffc2c685aac1171f9c25.svg";
export { ForwardRef as ReactComponent };